<template>
  <section :class="['section', muted ? 'section-muted' : '']">
    <UIContainer :narrow="narrow">
      <header v-if="title" class="section-title-bar">
        <h2 class="h2">{{ title }}</h2>
      </header>
      <slot />
    </UIContainer>
  </section>
</template>

<script>
import UIContainer from './UIContainer.vue'

export default {
  name: 'UISection',
  components: { UIContainer },
  props: {
    title: { type: String, default: '' },
    muted: { type: Boolean, default: false },
    narrow: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
</style>


